import { useEffect, useState } from 'react';

import { LogInModal } from '@jane/shared-ecomm/components';
import { useAuthentication } from '@jane/shared-ecomm/providers';

import { selectCustomer } from '../customer/redux/customer';
import { useCustomerSelector } from '../customer/selectors';

export const LoginModal = () => {
  const { authenticated: isLoggedIn } = useCustomerSelector(selectCustomer);
  const { defaultLogin, register, resetPassword, ...authProps } =
    useAuthentication();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    } else {
      setShowLoginModal(false);
    }
  }, [isLoggedIn]);

  return (
    <LogInModal
      {...authProps}
      location="header"
      onSignInSubmit={defaultLogin}
      onCreateAccountSubmit={register}
      onForgotPasswordSubmit={resetPassword}
      open={showLoginModal}
      onRequestClose={() => setShowLoginModal(false)}
    />
  );
};
